import * as React from 'react';

import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { CurrentCommunications } from '@components/communications/CurrentCommunications';
import * as UserStore from '@store/user';
import * as DocumentsStore from '@store/documents';
import * as Actions from '@store/actions/resources'

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...state.user,
        ...state.constants,
        ...UserStore.plainActions,
        ...DocumentsStore.plainActions,
        ...Actions.getDepartments,
        workId: state.user.work?.id,
    }),
    {},
)(CurrentCommunications as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
